import axios from "../../config/axiosConfig";
import {
  CREATE_SHORT_EXCESS, DELETE_SHORT_EXCESS,
  GET_SHORT_EXCESS,
  GET_SHORT_EXCESS_PAGE,
  SHORT_EXCESS_REQUEST_SUCCESS,
  SHORT_EXCESS_REQUEST,
  SHORT_EXCESS_REQUEST_FAILURE,
  UPDATE_SHORT_EXCESS
} from "../types/short-excess-types";

export const getShortExcessWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SHORT_EXCESS_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id'
      };
      return axios.get("/short-excess/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SHORT_EXCESS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getShortExcessById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SHORT_EXCESS_REQUEST });
    
      return axios.get(`/short-excess/get/${id}`).then((response) => {
        dispatch({ type: SHORT_EXCESS_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getShortExcess = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SHORT_EXCESS_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/short-excess/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SHORT_EXCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createShortExcess = (shortExcess) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: SHORT_EXCESS_REQUEST });
      const newShortExcess = {
        ...shortExcess
      };
      return axios.post("/short-excess/add", newShortExcess,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_SHORT_EXCESS, payload: response.data });
        } else {
          dispatch({
            type: SHORT_EXCESS_REQUEST_FAILURE,
            error: "Short Excess create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateShortExcess = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SHORT_EXCESS_REQUEST });
      const { auth } = getState();
      return axios.put("/short-excess/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_SHORT_EXCESS,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: SHORT_EXCESS_REQUEST_FAILURE,
            error: "Short Excess update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteShortExcess = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SHORT_EXCESS_REQUEST });
      return axios.delete(`/short-excess/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_SHORT_EXCESS, id: id });
          const include = ['id', 'Entry_No', 'Date', 'Account_Id'].join(',');
          const searchCols = ['Entry_No', ].join(',');
          const { inventory: { shortExcess: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getShortExcessWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SHORT_EXCESS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};